import useSwr from "swr";
export * from "./generated/index.js";
export * from "@amazeelabs/scalars";
export * from "luxon";
export var constants = {
    amountOfEventsOnHomePage: 5,
    siteName: "University of St.Gallen MBA",
    siteOrigin: "https://www.mba.unisg.ch"
};
export function useOperation(endpoint, operation, variables) {
    var _result_data;
    var result = useSwr([
        operation,
        variables
    ], variables ? function() {
        var url = new URL(endpoint, window.location.origin);
        url.searchParams.set("queryId", operation);
        url.searchParams.set("variables", JSON.stringify(variables));
        return fetch(url, {
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "SLB-Forwarded-Proto": window.location.protocol.slice(0, -1),
                "SLB-Forwarded-Host": window.location.hostname,
                "SLB-Forwarded-Port": window.location.port
            }
        }).then(function(r) {
            return r.json();
        });
    } : null, {
        suspense: false
    });
    return (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.data;
}
export function mutate(endpoint, operation, variables) {
    var url = new URL(endpoint, window.location.origin);
    return fetch(url, {
        credentials: "include",
        method: "post",
        body: JSON.stringify({
            queryId: operation,
            variables: variables
        }),
        headers: {
            "Content-Type": "application/json",
            "SLB-Forwarded-Proto": window.location.protocol.slice(0, -1),
            "SLB-Forwarded-Host": window.location.hostname,
            "SLB-Forwarded-Port": window.location.port
        }
    }).then(function(r) {
        return r.json();
    });
}
